import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function MoreIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="6.5" cy="11.5" r="1.5" fill={props.fill} />
			<circle cx="12.5" cy="11.5" r="1.5" fill={props.fill} />
			<circle cx="18.5" cy="11.5" r="1.5" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<MoreIcon fill={props.fill} />
		</div>
	);
}